<template>
  <div class="account-select" v-loading="loading">
    <div class="options" v-if="typeItems.length">
      <div
        class="item"
        v-for="(type, typeIndex) in typeItems"
        :key="typeIndex"
        :class="{ selected: selected.type === type.value }"
        @click="selected.type = type.value"
      >
        {{ type.label }}
      </div>
    </div>
    <div class="list" ref="list" v-if="selected.type !== 2">
      <div
        v-for="(item, index) in items"
        :key="item.userId + '-' + index"
        class="item"
        @click="selectUser(item)"
        :id="`item-${item.userId}`"
      >
        <div class="id-and-name">
          <div class="name">{{ item.userName }}</div>
          <div class="id">{{ item.userId }}</div>
        </div>
        <div
          class="select"
          :class="{ selected: selected.userId === item.userId }"
        ></div>
      </div>
    </div>
    <div class="guest-name" v-if="selected.type === 2">
      <input v-model="selected.userName" placeholder="游客昵称" />
    </div>
    <div class="actions">
      <div class="btn" @click="next" :disabled="loading">
        下一步
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "account-select",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    typeItems: {
      type: Array,
      default: () => []
    },
    defaultType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selected: {
        userName: "",
        userId: "",
        type: 0
      }
    };
  },
  watch: {
    "selected.type"(val) {
      if (val === 2) {
        this.selected.userId = "";
        this.selected.userName = utils.getGuestName();
      } else {
        this.selectUser();
      }
    }
  },
  mounted() {
    this.selected.type = this.defaultType;
    // this.selectUser();
  },
  methods: {
    selectUser(item) {
      if (!item) {
        const userName = localStorage.getItem("cs-login-userName") || "";
        let userId = localStorage.getItem("cs-login-userId") || "";
        if (userId) {
          userId = _.toNumber(userId);
        }
        if (userName && userId) {
          item = {
            userId,
            userName
          };
          this.$nextTick(() => {
            // this.$refs["list"].scrollTop =
            //   document.querySelector(`#item-${userId}`).offsetTop - 168;
          });
        } else {
          item = this.items[0];
        }
      }

      this.selected.userId = item.userId;
      this.selected.userName = item.userName;
      localStorage.setItem("cs-login-userId", item.userId || "");
      localStorage.setItem("cs-login-userName", item.userName || "");
    },
    next() {
      this.$emit("next", this.selected);
    }
  }
};
</script>

<style scoped lang="less">
.account-select {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background: #fff;
  box-shadow: 0 1px 3px 3px #ccc;
  border-radius: 4px;
  padding-bottom: 20px;
  border: 1px solid #555;

  .item {
    cursor: pointer;
    user-select: none;
    position: relative;

    &:hover {
      background-color: #eee;
    }

    &:active {
      box-shadow: inset 0 1px 2px 1px #ccc;
    }
  }

  .guest-name {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    input {
      width: 100%;
      height: 40px;
      border-radius: 4px;
      padding: 0 15px;
      outline: none;
      background-color: transparent;
      border: 1px solid #333;
    }
  }

  .list {
    margin-top: 20px;
    border-top: 1px solid #666;
    overflow-y: auto;
    max-height: 240px;
    border-bottom: 1px solid #666;

    .item {
      border-top: 1px solid #666;
      padding: 10px 15px;
      display: flex;
      align-items: center;

      &:first-child {
        border-top: none;
      }

      .id-and-name {
        flex: 1;
        display: flex;
        align-items: center;

        .id {
          margin-left: 50px;
        }
      }

      .select {
        position: relative;
        margin-left: 10px;
        width: 22px;
        height: 22px;
        background: #fff;
        border-radius: 50%;
        border: 1px solid #888;
        transition-duration: 0.3s;

        &:before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #333;
          border-radius: 50%;
          transition-duration: 0.2s;
        }

        &.selected {
          border: 1px solid #333;

          &:before {
            width: 60%;
            height: 60%;
          }
        }
      }
    }
  }

  .options {
    margin-top: 20px;
    display: flex;
    width: 100%;
    border-top: 1px solid #333;
    border-bottom: 1px solid #333;

    .item {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      height: 40px;

      &.selected {
        background: #333;
        color: #fff;
        border-style: solid;

        + .item {
          border-left-style: solid;
        }
      }
    }
  }

  .actions {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      padding: 10px 30px;
      border-radius: 4px;
      background: #000;
      color: #fff;
      cursor: pointer;
      user-select: none;

      &:active {
        opacity: 0.6;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .account-select {
    width: 100%;
    height: 100%;
    border: none;
    box-shadow: none;
    // top: 0;
    .list {
      max-height: 50vh;
    }
  }
}
</style>
